import { render, staticRenderFns } from "./MehrErfahrenLink.vue?vue&type=template&id=356e0e80&scoped=true&"
import script from "./MehrErfahrenLink.vue?vue&type=script&lang=js&"
export * from "./MehrErfahrenLink.vue?vue&type=script&lang=js&"
import style0 from "./MehrErfahrenLink.vue?vue&type=style&index=0&id=356e0e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e0e80",
  null
  
)

export default component.exports